import { render, staticRenderFns } from "./distribution-rules.vue?vue&type=template&id=6b1bbf13&"
import script from "./distribution-rules.vue?vue&type=script&lang=js&"
export * from "./distribution-rules.vue?vue&type=script&lang=js&"
import style0 from "./distribution-rules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports